<template>
  <NuxtLayout name="user-b2b-account">
    <slot></slot>

    <TrackOrderModal
      v-if="selectedOrder"
      v-model:isOpen="isTrackModalOpen"
      :order-id="selectedOrder.id"
      :statuses="selectedOrder.statuses"
      @close="selectedOrder = undefined"
    />

    <CancelOrderModal
      v-if="selectedOrder"
      v-model:isOpen="isCancelModalOpen"
      :loading
      :order-id="selectedOrder.id"
      @cancel-order="handleCancelOrder"
      @close="isCancelModalOpen = false"
    />
  </NuxtLayout>
</template>

<script setup lang="ts">
import CancelOrderModal from "~/components/features/UserManagement/Organism/Modals/CancelOrderModal.vue";
import TrackOrderModal from "~/components/features/UserManagement/Organism/Modals/TrackOrderModal.vue";
import useOrders from "~/composables/UserManagement/useOrders";
import paths from "~/constants/paths";

const {
  selectedOrder,
  isCancelModalOpen,
  isTrackModalOpen,
  loading,
  cancelOrder,
} = useOrders();

const route = useRoute();
const router = useRouter();

const handleCancelOrder = async () => {
  if (!selectedOrder.value) return;

  await cancelOrder(selectedOrder.value?.id);

  if (route.path === paths.account.orders.details)
    router.push(paths.account.orders.active);
};
</script>
